import AuditLogsContainer from './AuditLogsContainer'

export default AuditLogsContainer;